import { BASE_URL, CPR_AUTH, FAF_AUTH } from "../constant/Constants";
import axiosCall from "./axiosCall";
import forge from "node-forge";
import { decrypt, encrypt } from "./cryptoService";
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import base64 from "base-64";

//Get Treating Physicians details
export const fetchProviders = async (data) => {
    const response = await axiosCall('get', `/v1/data/D_SearchProviders`, null, null,data);

    return response;
}




//Get Primary Insurance Carriers list
export const fetchPrimaryInsuranceList = async (browserToken) => {
    // const browserToken = md5BToken;
    const res = await axiosCall('get', `/v1/data/D_GetLookUpValuesByID?`);

    return JSON.parse(res);
}

// Get Application View Details
export const fetchAppViewDetails = async ({ applicationID, prgData}) => {
    let authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    const response = await axiosCall('get', `/v1/data/D_ProcessApplication?`,authorization,`pyID=${applicationID}`,null, prgData);
    return {res:response.data, program:prgData}
}

// Get Claim View Details
export const fetchClaimViewDetails = async ({ PCaseID, prgData}) => {
    let authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    const response = await axiosCall('get', `/v1/data/D_ClaimDetailsByPCaseID?`,authorization,`pyID=${PCaseID}`,null, prgData);
    return {res:response.data, program:prgData}
}

// Get Claim View Details
export const fetchClaimViewDetailsDoc = async ({ PCaseID, prgData}) => {
    let authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    const response = await axiosCall('get', `/v1/data/D_ClaimDocumentListByAppID?`,authorization,`ClaimID=${PCaseID.ClaimID}&PortalUserID=${PCaseID.portalUserID}`,null, prgData);
    return {res:response.data, program:prgData}
}
